/* eslint-disable prefer-object-spread */
import { createReducer } from 'reduxsauce';
import Types from '../Actions/Types';

export const INITIAL_STATE = {
	fetchingCommoditiesData: false,
	commoditiesQuoteData: {}
};

const requestCommoditiesQuotes = state => {
	return Object.assign({}, state, {
		fetchingCommoditiesData: true
	});
};

const receiveCommoditiesQuotes = (state, action) => {
	return Object.assign({}, state, {
		fetchingCommoditiesData: false,
		commoditiesQuoteData: Object.assign({}, action.response)
	});
};

/**
 * Called by the saga in the finally block to ensure that in all cases the
 * fetching state for the call is set back to false to avoid infinite loader
 * and the ability to display both loaders and "sorry no data" messages.
 * @param {object} state
 * @param {object} action
 */
const handleLoader = (state, action) => {
	return Object.assign({}, state, {
		[action.fetchName]: false
	});
};

// map our types to our handlers
const ACTION_HANDLERS = {
	[Types.API_REQUEST_COMMODITIES_QUOTES]: requestCommoditiesQuotes,
	[Types.API_RECEIVE_COMMODITIES_QUOTES]: receiveCommoditiesQuotes,
	[Types.API_HANDLE_COMMODITIES_LOADER]: handleLoader
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
